import type { Blog } from '@ztechapps/common.contract'
import { BlogStatusEnum } from '@ztechapps/common.contract'

export const defaultCover =
  'https://res.cloudinary.com/tmmshauler/image/upload/v1629019833/common-for-all/bg-horizon.jpg'

export function createDefault(newValue?: Blog) {
  const defaultValue = {
    status: BlogStatusEnum.Draft,
  }

  return { ...defaultValue, ...newValue }
}
